import { Trip } from "../types/trip";

export const convertToYesNo = (value: any): string => {
  if (
    value === null ||
    value === undefined ||
    value === 0 ||
    value === '0' ||
    value === false ||
    value === '' ||
    (typeof value === 'string' && value.trim().toLowerCase() === 'false') ||
    (typeof value === 'string' && value.trim().toLowerCase() === 'no') ||
    (typeof value === 'string' && ['null', ''].includes(value.trim().toLowerCase())) ||
    Number.isNaN(value)
  ) {
    return 'No';
  }
  return 'Yes';
};

export const convertToBoolean = (value: any): boolean => {
  if (
    value === null ||
    value === undefined ||
    value === 0 ||
    value === '0' ||
    value === false ||
    value === '' ||
    (typeof value === 'string' && value.trim().toLowerCase() === 'false') ||
    (typeof value === 'string' && value.trim().toLowerCase() === 'no') ||
    (typeof value === 'string' && ['null', ''].includes(value.trim().toLowerCase())) ||
    Number.isNaN(value)
  ) {
    return false;
  }
  return true;
};

/**
 * Trip is cancelled when the following conditions are met:
 * 1. Reward granted is true: `trip.in_corridor` is true
 * 2. Trip validity is false: `trip.valid` is false
 */
export const isTripCancelled = (trip: Trip): string => {
  const isCancelled = convertToBoolean(trip.in_corridor) && !convertToBoolean(trip.valid)
  return convertToYesNo(isCancelled)
}
